module.exports = {

    data() {
        return {
            map: null,
        }
    },

    mounted() {
        App.bus.$on('google-maps-ready', (google) => {
            this.$nextTick(this.initializeMap)
        })
    },

    methods: {

        initializeMap() {

            let options = {
                zoom: 12,
                center: this.initLocation ? this.initLocation : {lat: 33.841684, lng: -118.3141641},
                styles: this.mapStyles,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false
            }

            const mapContainer = this.$refs.googleMap;

            this.map = new google.maps.Map(mapContainer, options)

            google.maps.event.addListener(this.map, 'dragend', () => this.onViewportChange());
            google.maps.event.addListener(this.map, 'zoom_changed', () => this.onViewportChange());

            this.$nextTick(() => {
                App.bus.$emit('google-map-loaded')
            })
        },

        onViewportChange(){
        },
    }
}
